import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '@/interface/store';
import { PurchaseOrder } from '@/interface/store/purchaseOrder';

export const initialState = () => {
  return {
    poData: {
      id: '',
      name: '',
      shipping: {
        amount: 0,
        currency: '',
      },
      tax: {
        amount: 0,
        currency: '',
      },
      total: {
        amount: 0,
        currency: '',
      },
      notes: null,
      createdAt: '',
      orderedAt: '',
      fkGroupId: '',
      fkOrderRequests: [],
    },
    poAttachments: [],
  };
};

export const state: PurchaseOrder = initialState();

const namespaced: boolean = true;

export const purchaseOrder: Module<PurchaseOrder, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
